export const TOTAL_VOTING_POWER_TOOLTIP_TEXT =
  'The current voting power of the satellite is taken by a snapshot at the beginning of each cycle. This is the voting power used in the calculations in governance.'

export const TOTAL_DELEGATED_MVN = 'All staked MVN that is delegated to satellites by users'
